import React from 'react';
import axios from 'axios';
import '../Styles/Home.css';
import '../Styles/Header.css';
import { withRouter } from "react-router-dom"; 
import GoogleLogin from 'react-google-login';
 import Modal from 'react-modal';
 import '../Styles/Login.css';
const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};
class Wallpaper extends React.Component {
  navigate = (Filter) => {
    this.props.history.push(Filter);
  }
constructor() {
        super();
        this.state = {
            restaurants: [],
            inputText: '',
            filteredRestaurants: [],
            locationData: [],
            loginModalIsOpen: false, 
            createaccountModalIsopen:false
         };
       }
    handleLocation = (event) => {
    const locationId = event.target.value;
    axios.get(`https://z-5dan.onrender.com/getallrestaurants/${locationId}`)
        .then(response => {
            this.setState({ restaurants: response.data });
        })
        .catch(error => {
            console.error('Error fetching restaurant data:', error);
        });
};
 handleSearch = (event) => {
    let searchText = event.target.value.toLowerCase();
    const { restaurants } = this.state;
    if (searchText === '') {
        this.setState({ inputText: '', filteredRestaurants: [] });
    } else {
        const filteredRestaurants = restaurants.filter((item) =>
            item.name.toLowerCase().includes(searchText)
        );
        this.setState({ inputText: searchText, filteredRestaurants });
    }
};
    showSuggestion = () => {
        const { filteredRestaurants, inputText } = this.state;
        if (filteredRestaurants.length === 0 && inputText ===undefined) {
            return null;
        }
        if (filteredRestaurants.length>0 && inputText === '') {
            return null;
        }
        if (filteredRestaurants.length ===0 && inputText!== '') {
            return (
                <ul className='ul1'>
                    <li className='list1'>No restaurants found</li>
                </ul>
            );
        }
       return (
            <ul className='ul1'>
                {filteredRestaurants.map((item, index) => (
                <li className='list1' key={index} onClick={() => this.selectingRestaurant(item)}>  
                     {`${item.name},${item.locality},${item.city}`}
                </li>
                ))}
            </ul>
        );
    }
   selectingRestaurant=(name)=>{
       this.props.history.push(`./details`);
    }
    handleLogin = () => {
        this.setState({ loginModalIsOpen: true });
      };
      handleCancel=()=>{
        this.setState({ loginModalIsOpen: false });
      }
      handleCreateAccount=()=>{
        this.setState({ createaccountModalIsopen: true });
      }
      handleCancelAccount=()=>{
        this.setState({createaccountModalIsopen : false });
      }
   render() {
    
        const { locationData} = this.props;
        const { backgroundColor, loginModalIsOpen, loggedUser, isloggedIn , createaccountModalIsopen} = this.state;
        // const {loginModalIsOpen,createaccountModalIsopen} = this.state;
        return (
            <div>
                <div style={{ position: "relative" }}>
                <img src="Assets/image1.jpg" alt="not found" width="100%" height="450" />
                </div>
                <div className="btn">
                         <button className="but1"onClick={this.handleLogin}>Login</button>
                        <button className="button2" onClick={this.handleCreateAccount}>Create an account</button>
                    </div> 
        <img src="./Assets/L1.jpeg"alt='/'style={{position:"relative"
,top:"-50vh", height:"100px",width:"100px", borderRadius:"50%",marginLeft:"45vw",marginTop:"-20vh"}}  onClick={() => this.navigate('./Filter')}/> 
                <div className="headings">Find the best Restaurants, cafes, bars</div>
                <div className="location">
                    <select className="Dropdown" onChange={this.handleLocation}>
                        <option value="0">Select</option>
                        {locationData.map((item) => (
                            <option key={item.location_id} value={item.location_id}>
                             {`${item.name},${item.city}`}
                            </option>
                        ))}
                    </select>
                </div>
              <div>
                <input className="restinput" type="text" placeholder="Please Enter Restaurant name"
                     onChange={this.handleSearch}/><br/>
                    {this.showSuggestion()}
                </div>
                <div>
        <nav className="navbar" style={{ backgroundColor: backgroundColor }}>
          <div className="container-fluid d-flex justify-content-end">
            <form className="d-flex">
            {!isloggedIn ? (
              <>
              
              <div className="btn-group" role="group" aria-label="Basic example">
                <button className="btn btn-outline-light mx-3" type="button" onClick={this.handleCreateAccount} >Create an account</button>
              </div>
              </>
             ) : (
              <>
              <div className="btn-group me-2" role="group" aria-label="Basic example">
                <button className="btn btn-light" type="button">{loggedUser}</button>
              </div>
              <div className="btn-group" role="group" aria-label="Basic example">
                <button className="btn btn-outline-light mx-3" type="button">Logout</button>
              </div>
              </> )}
            </form>
          </div>
        </nav>
        <Modal
          isOpen={loginModalIsOpen}
          style={customStyles}
          >
           <div>
          <GoogleLogin
    clientId="957651683796-ktrno6grovu40scij3apeku6ecr6sl83.apps.googleusercontent.com"
    buttonText="Continue  with Google"
    onSuccess={this.responseGoogle}
    onFailure={this.responseGoogle}
    cookiePolicy={'single_host_origin'}
  />
          </div>
          <h2>Login Form</h2>
          <div className="container">
            <label htmlFor="uname"><b>Username</b></label>
            <br/>
            <input type="text" placeholder="Enter Username" name="uname" required  className="Input1"/>
            <br/>
           <label htmlFor="psw"><b>Password</b></label>
           <br/>
            <input type="password" placeholder="Enter Password" name="psw" required className="Input1" />
            {/* <button type="submit"  className="button1" onclick={this.handleLogin}>Login</button> */}
          </div>

          <div className="container" style={{ backgroundColor: '#f1f1f1' }}>
            <button className="cancelbtn" onClick={this.handleCancel}>Cancel</button>
            <span className="psw">Forgot <a href="/">password?</a></span>
          </div>
        </Modal>
        <Modal
          isOpen={createaccountModalIsopen}
        
          >
<div class="container">
				<div class="row d-flex justify-content-center align-items-center h-100">
				<div class="col-lg-12 col-xl-11">
        <h2 style={{textAlign:"center",marginLeft:"50px"}} >Sign Up</h2>
				  <div class="card text-black" style={{borderRadius: "25px;"}}>
					<div class="card-body p-md-5">
					  <div class="row justify-content-center">
						<div class="col-md-10 col-lg-6 col-xl-5 order-2 order-lg-1">
		 <form >
							<div class="form-group">
								<label for="name"><h3>Name</h3></label>
								<input type="text" class="form-control" name="name" placeholder="Enter your Name" required/>
							  </div>
							<div class="form-group">
							  <label for="email"><h3>Email address</h3></label>
							  <input type="email" class="form-control" name="email" aria-describedby="emailHelp" placeholder="Enter email" required/>
							  <small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small>
							</div>
              <div>
                    <i class="fas fa-lock fa-lg me-3 fa-fw"></i>
                    <div data-mdb-input-init class="form-outline flex-fill">
                    <label class="form-label" for="form3Example4c"><h3>Password</h3></label>
                      <input type="password" id="form3Example4c" class="form-control" required />
                    
                    </div>
                  </div>
							<div >
                    <input class="form-check-input me-2" type="checkbox" value="" id="form2Example3c" />
                    <label class="form-check-label" for="form2Example3">
                      I agree all statements in <a href="#!">Terms of service</a>
                    </label>
                  </div>
                  <button type="submit" style={{backgroundColor:"blue",color:"white",marginTop:"20px"}}>Register</button>
                  <div style={{marginright:"10px",display:"inline-block"}}>
               
          <GoogleLogin
    clientId="957651683796-ktrno6grovu40scij3apeku6ecr6sl83.apps.googleusercontent.com"
    buttonText="Continue  with Google"
    onSuccess={this.responseGoogle}
    onFailure={this.responseGoogle}
    cookiePolicy={'single_host_origin'}
  />
          </div>
          
						</form> 
            <div className="container" >
            <button className="cancelbtn" onClick={this.handleCancelAccount}>Cancel</button>
            
          </div>
        		</div>
						<div class="col-md-10 col-lg-6 col-xl-7 d-flex align-items-center order-1 order-lg-2">
		  
						  <img src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-registration/draw1.webp"
							class="img-fluid" alt="Sample "/>
		  
						</div>
					  </div>
					</div>
				  </div>
				</div>
			  </div>
			</div>
	</Modal>
  </div>
             
       </div>
        );
    }
}
export default withRouter(Wallpaper);







